/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `Surcharge`   - german: Zuschlag * `Discount`    - german: Abschlag
 */
export const ConditionKind = {
  Surcharge: 'Surcharge',
  Discount: 'Discount',
} as const;
export type ConditionKind = (typeof ConditionKind)[keyof typeof ConditionKind];
